import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Navbar } from "./Navbar";
import PoweredBy from "./poweredBy";

export const Layout = ({ children }) => {
  const location = useLocation();

  // Map routes to page titles
  const getPageTitle = () => {
    const path = location.pathname;

    // Route to title mapping
    const routeMap = {
      "/": "Dashboard",
      "/dashboard": "Dashboard",
      "/stops": "Stops",
      "/stops/create": "Stops",
      "/stops/view": "Stops",
      "/trips": "Trips",
      "/trips/create": "Trips",
      "/trips/view": "Trips",
      "/trip-cost": "Trip Cost",
      "/cost/create": "Trip Cost",
      "/cost/view": "Trip Cost",
      "/milestones": "Milestone",
      "/milestone/create": "Milestone",
      "/livetrack": "Live View",
      "/triptrack": "Live View",
      "/vehicles": "Vehicle",
      "/vehicle/create": "Vehicle",
      "/vehicle/view": "Vehicle",
      "/customers": "Customer",
      "/customer/create": "Customer",
      "/customer/view": "Customer",
      "/vendor": "Vendor",
      "/vendor/create": "Vendor",
      "/vendor/view": "Vendor",
      "/reports": "Reports",
      "/products": "Product",
      "/product/create": "Product",
      "/product/view": "Product",
      "/unauthorized": "Unauthorized",
    };

    return routeMap[path] || "Dashboard";
  };

  const pageTitle = getPageTitle();

  return (
    <div className="d-flex">
      <Sidebar currentfile={pageTitle} />
      <div
        className="flex-grow-1 d-flex flex-column"
        style={{
          width: "calc(100vw - 80px)",
          height: "calc(100vh)",
          overflow: "hidden",
          overflowX: "hidden",
        }}
      >
        <Navbar pageTitle={pageTitle} />
        <div className="bg-half-white pt-0 px-2 overflow-y-auto scroll-bar flex-grow-1" style={{ overflowX: "hidden" }}>
          {children}
          <PoweredBy style={{ position: "absolute", bottom: "0", right: "0", width: "110%" }} />
        </div>
      </div>
    </div>
  );
};
